import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=21390022&scoped=true&"
import script from "./Impersonate.vue?vue&type=script&lang=js&"
export * from "./Impersonate.vue?vue&type=script&lang=js&"
import style0 from "./Impersonate.vue?vue&type=style&index=0&id=21390022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21390022",
  null
  
)

export default component.exports